module.exports = new __parcel__URL__("mage.16133bbc.png").toString();